<div class="container">
  <img src="/assets/ZeroPay overlay circle1.png" class="overlay-img" />
  <div fxLayout="row wrap">
    <div fxFlex="100">
      <h1 class="Join-title" [innerHTML]="title ? title : 'Benefits of using <span>ZeroPay</span>'"></h1>
      <br />
      <div fxLayout="row wrap">
        <div fxFlex.gt-sm="5" fxFlex.lt-sm="0" fxFlex.lt-md="0"></div>
        <div fxFlex.gt-sm="15" fxFlex.lt-sm="50">
          <div class="zeropay-benefit">
            <img src="/assets/icons/benefits/benefit_icon_3_payments.png" />3
            simple payments.
          </div>
        </div>
        <div fxFlex.gt-sm="15" fxFlex.lt-sm="50">
          <div class="zeropay-benefit">
            <img
              src="/assets/icons/benefits/benefit_icon_no_interest.png"
            />Zero fees and Zero interest.
          </div>
        </div>
        <div fxFlex.gt-sm="15" fxFlex.lt-sm="50">
          <div class="zeropay-benefit">
            <img
              src="/assets/icons/benefits/benefit_icon_approval.png"
            />Approval in 1 minute.
          </div>
        </div>
        <div fxFlex.gt-sm="15" fxFlex.lt-sm="50">
          <div class="zeropay-benefit">
            <img src="/assets/icons/benefits/benefit_icon_no_documents.png" />No
            documents required for signup.
          </div>
        </div>
        <div fxFlex.gt-sm="15" fxFlex.lt-sm="50">
          <div class="zeropay-benefit">
            <img src="/assets/icons/benefits/benefit_icon_shipping.png" />Get
            your order right away.
          </div>
        </div>
        <div fxFlex.gt-sm="15" fxFlex.lt-sm="50">
          <div class="zeropay-benefit">
            <img
              src="/assets/icons/benefits/benefit_icon_payover.png"
            />Payments are made over 2 to 3 months.
          </div>
        </div>
        <div fxFlex.gt-sm="5" fxFlex.lt-sm="0" fxFlex.lt-md="0"></div>
      </div>
    </div>
  </div>
</div>
